<template>
  <showComponent v-if="!isLoading" entityName="hotel_hotel" :id="hotelId" />
</template>

<script>
import showComponent from '@/components/backoffice/show/showComponent'
import CommonApi from '@/api/commonApi'

export default {
  components: {
    showComponent
  },
  data () {
    return {
      hotelId: this.$route.params.id,
      isLoading: true,
      commonApi: new CommonApi()
    }
  },
  async mounted () {
    let response = await this.commonApi.getHotelId()
    if (response.data.success) {
      this.isLoading = false
      this.hotelId = response.data.data.id
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
  .card-body{
    padding: 0;
  }
</style>
